import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { FullOffer } from 'app/shared/models/class/offer/offer';
import { OfferSession } from 'app/shared/models/class/session/session';
import { Trainee, TraineeFullOffer } from 'app/shared/models/class/trainee/trainee';

interface DialogData {
  offer: FullOffer;
  quantity: number;
  showError: boolean;
  counterSessionBasketKey: number;
  userKey: number;
  sessionKey: number;
}

@Component({
  selector: 'app-opendialog-customize-my-session',
  templateUrl: './opendialog-customize-my-session.component.html',
  styleUrls: ['./opendialog-customize-my-session.component.scss']
})
export class OpendialogCustomizeMySessionComponent implements OnInit {

  traineeActive: Trainee[] = [];
  traineeSelection: Trainee[] = [];
  trainees: TraineeFullOffer[] = this.data.offer.trainees || [];
  sessionSelected: OfferSession;
  limitTrainees: number;
  quantity: any;
  sizeWindow: number;

  constructor(
    public dialogRef: MatDialogRef<OpendialogCustomizeMySessionComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData,

  ) {
  }

  ngOnInit(): void {
    this.sizeWindow = window.innerWidth;
  }

  updateQuantity(event: any): void {
    this.quantity = event?.length;
  }

  closeDialog(): void {
    this.dialogRef.close({ data: { quantity: this.quantity } });
  }

}
